module.exports = "<igo-list [navigation]=\"false\" [selection]=\"false\">\r\n  <ng-template ngFor let-datasource [ngForOf]=\"datasources | filterableDataSource: 'time'\">\r\n    <igo-time-filter-item igoListItem [datasource]=\"datasource\"></igo-time-filter-item>\r\n  </ng-template>\r\n\r\n  <ng-content></ng-content>\r\n</igo-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/filter/time-filter-list/time-filter-list.component.html
// module id = 1014
// module chunks = 0